import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { ENTER } from 'Utils/keyCodes';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  dataTestid?: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onClick?: (e: React.SyntheticEvent) => unknown;
  tabIndex?: number;
};
export const RadioButton = ({
  className,
  dataTestid,
  isChecked,
  isDisabled,
  onClick,
  tabIndex = 0,
}: Props) => {
  const _onClick = (event) => {
    if (!isDisabled && onClick) {
      onClick(event);
    }
  };

  const _onKeyPress = (event) => {
    if (event.which === ENTER) {
      _onClick(event);
    }
  };

  return (
    <span
      className={classnames(
        'outline-custom-sibling flex size-24 shrink-0 rounded-full border border-black p-2 text-saffron',
        {
          'cursor-not-allowed border-grey bg-pearl text-lightGrey': isDisabled,
        },
        className,
      )}
      data-testid={dataTestid}
      role="button"
      tabIndex={tabIndex}
      onClick={_onClick}
      onKeyPress={_onKeyPress}
    >
      <Icon
        className={classnames({
          'opacity-0': !isChecked,
        })}
        name={ICONS.FAT_DOT}
        width="100%"
      />
    </span>
  );
};
